/** Kód datové sady „Výdej PSPI" (1.5.0.1, změna #10). */
export const TYP_DATOVE_SADY_VYDEJ_PSPI = 11;
//# sourceMappingURL=types.js.map